var c3 = require('c3');
var c3Styles = require('../../stylesheets/vendor/c3.css');
var m = require('mithril');
var moment = require('moment-timezone');
var dateFormat = 'MM/DD/YYYY hh:mm A';

module.exports = {
  oncreate : function (vnode) {
    var defaultConfig = {
      size: {
        height: 500,
      },
      legend: {
        position: 'inset'
      },
      zoom: {
        enabled: false
      },
      data: {
        type: 'line',
        x: 'x',
        rows: [['']]
      },
      point: {
        show: false
      },
      axis: {
        x: {
          type: 'timeseries',
          tick: {
            fit: true,
            count: 4,
            fit: true,
            format: function (ts) { 
              var date = moment(Math.floor(ts / 1e3));
              return date.format(dateFormat);
            } 
          }
        }
      }
    }

    this.chart = c3.generate({...defaultConfig, ...vnode.attrs.options, bindto: vnode.dom});
  },
  onupdate:function(vnode){
    var chart = vnode.state.chart;
    var options= vnode.attrs.options;
    
    if(options && options.data && options.data.type =="gauge" && this.lastValue != options.data.columns[0][1]){
      this.lastValue = options.data.columns[0][1];
      chart.load({
        columns: [['data', options.data.columns[0][1]]]
      });
    }
    (()=>{
      var elementDiv = document.getElementById(vnode.attrs.idDiv);
      if(elementDiv && vnode.attrs.resize) {
        let heigthDiv = elementDiv.offsetHeight;
        let widthDiv = elementDiv.offsetWidth;
        chart.resize({height: heigthDiv, width: widthDiv})
      }
    })()

    
  },
  view : function (vnode) {
    window.addEventListener("resize", m.redraw);
    return m('div', {id: vnode.attrs.idDiv ? vnode.attrs.idDiv : ''})
  }
};
